module.exports = __webpack_public_path__ + "static/media/barbarian.abe8546f.svg";